module.exports = __webpack_public_path__ + "img/winlift-managers.f0b33667.png";